import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Reports } from '../../shared/interfaces';
import { LanguageService } from '../../shared/services';
import { environment } from './../../../environments/environment';
import { DxTreeViewModule, DxTreeViewComponent } from 'devextreme-angular';
import { DxTreeViewTypes } from 'devextreme-angular/ui/tree-view';

export class ReportTreeItem {
  leaf?: boolean;
  items!: ReportTreeItem[];

  constructor(
    public id: string,
    public grp: string,
    public subgrp: string,
    public text?: string | undefined,
    public description?: string | undefined,
    public uom?: string | undefined,
    public modifiedAt?: string | undefined,
  ) { }
}

export class ReportItem {
  constructor(
    public id: string,
    public grp: string,
    public subgrp: string,
    public text?: string | undefined,
    public description?: string | undefined,
    public uom?: string | undefined,
    public modifiedAt?: string | undefined,
  ) { }
}


@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  standalone: false
})
export class ReportsComponent implements OnInit {

  isMysqlDriver: boolean;
  values!: Reports;
  nodes!: any;
  listTree!: any;
  treeItems!: ReportTreeItem[];
  reportTreeStructure!: any;

  currentSubgrp!: string;
  reportItems!: ReportItem[];
  currentItems!: ReportItem[];

  listConponent: any = null;

  private label!: string;
  private soQ4Reports = [
    'HaviSzenMerleg',
    'HaviOlajKeszlet',
    'EvesOlajMerleg',
    'EvesFoldgazMerleg',
    'IEAegyszerusitett',
    'IEAreszletes',
    'EvesHoMerleg',
    'HaviBruttoVillany'
  ]

  constructor(
    public languageService: LanguageService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.isMysqlDriver = environment.DB_DRIVER === "mysql" || false;
  }

  ngOnInit(): void {
    this.activatedRoute.data.subscribe(({ reports }) => {

      // const filteredReports = reports.items.value.filter(
      //   (report: any) => !this.soQ4Reports.includes(report.id)
      // )
      // const currentDate = new Date().toISOString().split('T').shift();
      // this.values = ( currentDate && (currentDate > '2023-10-31')) ? filteredReports : reports.items.value;

      this.values = reports.items.value;
      // console.debug("Values: ", this.values)

      const lang = this.languageService.language;
      this.reportItems = this.values.map((report) => {
        let item
        if (this.isMysqlDriver) {
          item = new ReportTreeItem(
            report.id,
            report.grp,
            report.subgrp,
            lang === 'hu' ? report.title_hu : report.title_en,
            lang === 'hu' ? report.description_hu : report.description_en,
            (report.batches[0]?.modified) ? report.batches[0]?.modified : report.modified
          );
        } else {
          item = new ReportTreeItem(
            report.id,
            report.grp,
            report.subgrp,
            lang === 'hu' ? report.title_hu : report.title_en,
            lang === 'hu' ? report.description_hu : report.description_en,
            "", // lang === 'hu' ? `Mértékegység: ${report.uom_hu}` : `Unit of measure: ${report.uom_en}`,
            (report.batches[0]?.modifiedAt) ? report.batches[0]?.modifiedAt : report.modifiedAt
          );
        }
        return item;
      });

      this.currentSubgrp = this.values[0]?.subgrp;
      this.fileterCurrentItems(this.currentSubgrp);

      this.nodes = reports.nodes.value;
      // console.debug("Nodes: ", this.nodes)

      this.treeItems = this.values.map((report) => {
        let item = new ReportTreeItem(
          report.id,
          report.grp,
          report.subgrp,
        );
        return { ...item, leaf: true };
      });
      // console.log('reportTree: ', this.treeItems)
      this.reportTreeStructure = this.createTree(this.treeItems);
      // console.debug("reportTreeStructure: ", this.reportTreeStructure)
    });

  }

  treeContentReady(e: any) {
    // console.debug('The tree content now is ready', e)
    if (this.currentSubgrp) {
      e.component.selectItem(this.currentSubgrp);
    }
  }

  // listComponetReady(e: any) {
  //   console.debug('The list content now is ready', e)
  //   if (!this.listConponent) {
  //     this.listConponent = e.component;
  //   }
  // }

  selectReportCategory(e: DxTreeViewTypes.ItemClickEvent) {
    console.log('Selected: ', e.itemData!.text);
    if (this.currentSubgrp !== e.itemData!.id) {
      // @ts-ignore
      if (e.itemData!.leaf) {
        this.currentSubgrp = e.itemData!.id as string;
        this.fileterCurrentItems(this.currentSubgrp);
      } else {
        e.component.unselectItem(e.itemData?.id);
      }
    }
  }

  reportSelected(e: any) {
    const selectedReport = this.currentItems[e.itemIndex]
    this.navigateTo(selectedReport)
  }

  navigateTo(itemData: ReportItem) {
    this.router.navigate(['generated-report', `${itemData.id}`]);
  }

  // treeViewSelectionChanged(e: DxTreeViewTypes.SelectionChangedEvent) {
  //   console.debug("TreeSelectionChanged: ", e)
  //   // this.syncSelection(e.component);
  // }

  treeViewContentReady(e: DxTreeViewTypes.ContentReadyEvent) {
    // this.syncSelection(e.component);
  }

  syncSelection(treeView: DxTreeViewComponent['instance']) {
    this.fileterCurrentItems(this.currentSubgrp);
  }

  private createTree(reports: ReportTreeItem[]) {
    const l1_items = reports.reduce((group: { [key: string]: ReportTreeItem[] }, item) => {
      group[item.grp] = group[item.grp] ?? [];
      group[item.grp].push(item);
      return group;
    }, {});

    return Object.entries(l1_items).map(([key, value]) => {
      const l1 = {
        id: key,
        text: this.languageService.get(`treeitem_${key}`) || key,
        expanded: true,
        leaf: false,
        disabled: true,
        items: this.createL2Tree(value)
      }
      return l1;
    })
  }

  private createL2Tree(reports: ReportTreeItem[]) {
    const l2_items = reports.reduce((group: { [key: string]: ReportTreeItem[] }, item) => {
      group[item.subgrp] = group[item.subgrp] ?? [];
      group[item.subgrp].push(item);
      return group;
    }, {});

    return Object.entries(l2_items).map(([key, value]) => {
      const l2 = {
        id: key,
        text: this.languageService.get(`treeitem_${key}`) || key,
        icon: "bulletlist",
        leaf: true,
        // expanded: true,
        // items: value
      }
      return l2;
    })
  }

  private fileterCurrentItems(subgrp: string) {
    this.currentItems = this.reportItems.filter((item: ReportItem) => item.subgrp === subgrp)
    console.debug("Current Items:", this.currentItems);
    if (this.listConponent) this.listConponent.repaint();
  }

}
